// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1J3R2","content":"GlobalSearch_content__1TDK_"};